module.exports = __webpack_public_path__ + "static/media/griffith-college.7da11ee1.png";